import {FormsFileData, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalFormsFileData extends FormsFileData implements Parameter {
	public name?: string;
	public mimetype?: string;

	constructor(data: any) {
		super(data);

		this.name = FunctionHelper.exists(data?.name) ? data.name : "";
		this.mimetype = FunctionHelper.exists(data?.mimetype) ? data.mimetype : "";
	}

	public static getName(): string {
		return "";
	}

	public static getMimetype(): string {
		return "";
	}

	public static fromJson(data: any): PortalFormsFileData {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalFormsFileData(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'name': this.name,
			'mimetype': this.mimetype
		};
	}

	public clone(): PortalFormsFileData {
		return PortalFormsFileData.fromJson(this.toJson());
	}
}